/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Paypal_DescriptionInputs */

const en_admin_settings_groups_paypal_description = /** @type {(inputs: Admin_Settings_Groups_Paypal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PayPal payment gateway`)
};

/**
* | output |
* | --- |
* | "PayPal payment gateway" |
*
* @param {Admin_Settings_Groups_Paypal_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_paypal_description = /** @type {((inputs?: Admin_Settings_Groups_Paypal_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Paypal_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_paypal_description(inputs)
});
export { admin_settings_groups_paypal_description as "admin.settings.groups.paypal.description" }